import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IntegradorService } from '../../../../../services/integrador.service';
import { ToastService } from '../../../../../services/toast.service';
import { ClasseAvaliacao } from '../../../../../types/ClasseAvaliacao.type';
import { Empresa } from '../../../../../types/Empresa.type';

@Component({
  selector: 'app-classeavaliacaoform',
  templateUrl: './classeavaliacaoform.component.html',
  styleUrl: './classeavaliacaoform.component.css'
})
export class ClasseAvaliacaoFormComponent implements OnInit {

  classeAvaliacao: ClasseAvaliacao = {} as ClasseAvaliacao
  classeAvaliacaoCadastro: ClasseAvaliacao = {} as ClasseAvaliacao;
  empresas: Empresa[] = [];

  constructor(private integradorService: IntegradorService, private toastService: ToastService, private activatedRoute: ActivatedRoute, private location: Location){}

  ngOnInit(){
    this.buscaClasseAvaliacao()
    this.buscaEmpresas();
  }

  buscaClasseAvaliacao(){
    let id = this.activatedRoute.snapshot.paramMap.get('id');

    if(id){
      this.integradorService.getClasseAvaliacao(id).subscribe({
        next: (data) => {
          this.classeAvaliacao = data
        },
        error: (error) => {
          console.error(error)
          this.toastService.erro("Erro", error.error.message)
        }
      })
    }
  }

  buscaEmpresas(){
    this.integradorService.getEmpresas().subscribe({
      next: (data) => {
        this.empresas = data
      },
      error: (error) => {
        console.error(error)
        this.toastService.erro("Erro", error.error.message)
      }
    })
  }

  salvar() {
    Object.assign(this.classeAvaliacaoCadastro, this.classeAvaliacao);

    this.classeAvaliacaoCadastro.classeAvaliacao = this.classeAvaliacaoCadastro.classeAvaliacao?.trim() != '' ? this.classeAvaliacaoCadastro.classeAvaliacao : null;
    this.classeAvaliacaoCadastro.contaContabil = this.classeAvaliacaoCadastro.contaContabil?.trim() != '' ? this.classeAvaliacaoCadastro.contaContabil : null;

    if (this.classeAvaliacao.id) {

      this.integradorService.putClasseAvaliacao(this.classeAvaliacaoCadastro).subscribe({
        next: () => {
          this.toastService.sucesso('Sucesso', 'Classe Avaliação atualizada com sucesso');
          this.fecharDialog();
        },
        error: (value) => {
          this.toastService.erro('Erro', 'Erro ao salvar: ' + value.error.message);
        },
      });
    } else {

      this.integradorService.postClasseAvaliacao(this.classeAvaliacaoCadastro).subscribe({
        next: (valor) => {
          Object.assign(this.classeAvaliacao, valor);
          this.toastService.sucesso('Sucesso', 'Classe Avaliação salva com sucesso');
          this.fecharDialog();
        },
        error: (value) => {
          this.toastService.erro('Erro', 'Erro ao salvar: ' + value.error.message);
        },
      });
    }
  }

  buscaEmpresaSelecionada = (empresaErp: string): Empresa | undefined => {
    return this.empresas.find(empresa => empresa.empresaErp === empresaErp);
  };

  fecharDialog() {
    this.classeAvaliacao = {} as ClasseAvaliacao;
    this.location.back();
  }
}
